module.exports = __webpack_public_path__ + "static/Red and Grey Siding and Silver - Cladding-29ed7599260f59d99059193b2ed0c39e.jpg";